/**
 * @fileoverview Event bullet — small dot used on the mobile month-view
 * cells when there isn't room for the full badge. Ported as-is.
 */

import { cva } from "class-variance-authority";

import { cn } from "@/utils/misc";

import type { TEventColor } from "@/calendar/types";

const eventBulletVariants = cva("size-2 rounded-full", {
  variants: {
    color: {
      blue: "bg-blue-600 dark:bg-blue-500",
      green: "bg-green-600 dark:bg-green-500",
      red: "bg-red-600 dark:bg-red-500",
      yellow: "bg-yellow-600 dark:bg-yellow-500",
      purple: "bg-purple-600 dark:bg-purple-500",
      gray: "bg-neutral-600 dark:bg-neutral-500",
      orange: "bg-orange-600 dark:bg-orange-500",
      pink: "bg-pink-600 dark:bg-pink-500",
    },
  },
  defaultVariants: {
    color: "blue",
  },
});

export function EventBullet({
  color,
  className,
}: {
  color: TEventColor;
  className?: string;
}) {
  return <div className={cn(eventBulletVariants({ color }), className)} />;
}
